import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { api } from '../../models/api-url.model';
import { Task } from '../../models/task.model';
import { ApiService } from '../../core/services/api';

@Injectable({
  providedIn: 'root',
})
export class TaskService {
  private readonly apiService = inject(ApiService);

  getTasks(orderId: string): Observable<Task[]> {
    return this.apiService.get(`${api.ordersURL}/${orderId}${api.tasksURL}`);
  }
}
